import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import formMixin from 'mixins/user-form-mixin';
import validationMixin from 'mixins/validationMixin';
import CargomaticRadio from 'components/v2/forms/Radio';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';
import ROLES from 'constants/UserRoles';
import { Alert } from 'react-bootstrap';
import { humanize } from 'underscore.string';
import ReviewBankingModal from './review-banking-modal';
import Representative from './carrier-representative';
import EditableSection from '../../../v2/EditableSection';
import DescriptionListItem from '../../../v2/DescriptionListItem';

const VERIFIED = 'verified';
const PENDING = 'pending';

class BillingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routing: '',
      account: '',
      legalEntity: '',
      showReviewBankingModal: false,
      errors: [],
    };
  }

  onUpdate() {
    if (this.props.onSave) this.props.onSave(this.state);
  }

  getValidationErrors() {
    const { t } = this.props;
    const accountErrors = [];
    const bankingRequiredFields = ['routing', 'account'];
    bankingRequiredFields.forEach((field) => {
      if (!this.state[field]) {
        accountErrors.push({
          field: field,
          value: this.state[field],
          error: t('REQUIRED_FOR_BANKING'),
        });
      }
    });
    return accountErrors;
  }

  onSaveLegalEntity(value) {
    let accountErrors = [];
    const data = {};
    const sendBankAccount = this.state.routing || this.state.account;

    if (sendBankAccount) accountErrors = this.getValidationErrors();

    if (!value.errors.concat(accountErrors).length) {
      if (sendBankAccount) {
        data.routing = this.state.routing;
        data.account = this.state.account;
      }
      delete value.errors;
      if (value.type === 'individual') {
        delete value.business_name;
        delete value.business_tax_id;
      }

      data.legal_entity = value;
      data.userId = this.props.details.id;
      this.props.onSave(data);
      return true;
    }

    this.setState({ errors: accountErrors });
    return false;
  }

  handleDismissAlert = () => {
    this.setState({ errors: [] });
  };

  renderBankingInfoErrors() {
    const { errors } = this.state;
    if (errors.length === 0) {
      return null;
    }
    return (
      <div className="col-span-2">
        <Alert bsStyle="danger" onDismiss={this.handleDismissAlert}>
          <ul>
            {errors.map((error, i) => (
              <li key={i}>
                {humanize(error.field)}: {humanize(error.error)}
              </li>
            ))}
          </ul>
        </Alert>
      </div>
    );
  }

  onBankingModalClose = () => {
    this.setState({
      showReviewBankingModal: false,
    });
  };

  onOpenReviewBankingModal = () => {
    const { t } = this.props;
    const loggedInUser = SessionStore.getUser();
    if (loggedInUser.roles.includes(ROLES.FINANCE_ADMIN)) {
      this.setState({
        showReviewBankingModal: true,
      });
    } else {
      showToast({
        title: 'Error',
        body: t('NEED_FINANCE_ADMIN_PERMISSION'),
        level: 'error',
      });
    }
  };

  renderBankingInfoSummary = () => {
    const { t } = this.props;

    return (
      <>
        {this.props.details.stripe_account_id && (
          <>
            <DescriptionListItem label={t('ROUTING_NUMBER')}>
              {this.state.routing || '-'}
            </DescriptionListItem>
            <DescriptionListItem label={t('ACCOUNT_NUMBER')}>
              {this.state.account || '-'}
            </DescriptionListItem>
          </>
        )}

        {this.props.details.all_banking_info_approved &&
          this.props.details?.is_partner_with_factoring_company &&
          this.props.details?.factoring_company_name?.length && (
            <>
              <CargomaticRadio
                id="partner_company_checkbox_form"
                className="col-span-2"
                checked={this.props.details.is_partner_with_factoring_company}
                disabled
                name="partnerCompanyRadio1"
                value={this.props.details.is_partner_with_factoring_company}
                onChange={() => {}}
              >
                {t('PARTNER_WITH_FACTORING_COMPANY')}
              </CargomaticRadio>
              <p className="col-span-2">
                {this.props.details?.factoring_company_name}
              </p>
            </>
          )}
      </>
    );
  };

  renderBankingInfoForm = () => {
    const { t } = this.props;

    return (
      <>
        {this.renderBankingInfoErrors()}

        {this.props.details.stripe_account_id && (
          <>
            <div className="">
              <label className="block mb-2 form-label">
                {t('ROUTING_NUMBER')}
              </label>
              <input
                className="w-full mb-4 form-field"
                value={this.state.routing}
                placeholder={t('ROUTING_NUMBER')}
                onChange={(e) => this.setState({ routing: e.target.value })}
              />
            </div>
            <div className="">
              <label className="block mb-2 form-label">
                {t('ACCOUNT_NUMBER')}
              </label>
              <input
                className="w-full mb-4 form-field"
                value={this.state.account}
                placeholder={t('ACCOUNT_NUMBER')}
                onChange={(e) => this.setState({ account: e.target.value })}
              />
            </div>
          </>
        )}

        {this.props.details.all_banking_info_approved && (
          <div className="col-span-2">
            {this.props.details?.is_partner_with_factoring_company &&
              this.props.details?.factoring_company_name?.length && (
                <>
                  <CargomaticRadio
                    id="partner_company_checkbox_form"
                    checked={
                      this.props.details.is_partner_with_factoring_company
                    }
                    disabled
                    name="partnerCompanyRadio1"
                    value={this.props.details.is_partner_with_factoring_company}
                    onChange={() => {}}
                  >
                    {t('PARTNER_WITH_FACTORING_COMPANY')}
                  </CargomaticRadio>
                  <p className="mx-8">
                    {this.props.details?.factoring_company_name}
                  </p>
                </>
              )}
          </div>
        )}

        {!this.props.details.all_banking_info_approved && (
          <div className="col-span-2 justify-self-center">
            <button
              className="button bg-orange-400 text-white px-8"
              onClick={this.onOpenReviewBankingModal}
            >
              {t('REVIEW_BANKING_INFORMATION')}
            </button>
          </div>
        )}
      </>
    );
  };

  render() {
    const { t } = this.props;
    const details = this.props.details;
    let currentAccount = t('NO_BANK_ACCOUNT_REGISTERED');
    const bankAccounts = details.bank_accounts.external_accounts || [];
    const accountData = bankAccounts[0];
    let verified = 'unverified';
    let linkToStripeAccount = '';

    if (details.stripe_account_id) {
      const stripeId = details.stripe_account_id;
      const stripeUrl = `${STRIPE_URL}/applications/users/${stripeId}`;
      linkToStripeAccount = (
        <a
          href={stripeUrl}
          target="_stripe"
          title="Stripe ID"
          className="stripeId"
        >
          {t('VIEW_IN_STRIPE')}
        </a>
      );
    } else {
      currentAccount += ` ${t('ADD_BILLING_INFORMATION')}`;
    }

    if (accountData) {
      currentAccount = `${accountData.bank_name} - ending in ${accountData.last4}`;
    }

    if (details.stripe_verification) {
      verified = details.stripe_verification.status;
    }

    const canEdit = !!SessionStore.hasFinanceAdminRole();

    return (
      <>
        {this.state.showReviewBankingModal && (
          <ReviewBankingModal
            show={this.state.showReviewBankingModal}
            onClose={this.onBankingModalClose}
            onConfirmDetails={this.props.onHandleBankingInfoAccept}
            onDeclineDetails={this.props.onHandleBankingInfoDecline}
            sensitiveDocumentData={this.props.sensitiveDocumentData}
            onGetVerificationData={this.props.onGetVerificationData}
            partnerWithFactoringCompany={
              this.props.details.is_partner_with_factoring_company
            }
            partnerFactoringCompanyName={
              this.props.details.factoring_company_name
            }
          />
        )}

        <div className="lg:grid lg:grid-cols-2 lg:gap-4">
          {verified !== VERIFIED && verified !== PENDING && (
            <Representative
              verified={verified}
              onSave={(value) => this.onSaveLegalEntity(value)}
              carrier_id={this.props.details._id}
              linkToStripeAccount={linkToStripeAccount}
            />
          )}

          <EditableSection title={t('BANKING_INFORMATION')} canEdit={canEdit}>
            {(editing, saving, onSaveSuccess) => {
              if (saving) {
                this.onUpdate();
                onSaveSuccess();
              }

              return (
                <div className="grid grid-cols-2 gap-4">
                  <DescriptionListItem
                    label={t('CURRENTLY')}
                    className="col-span-2"
                  >
                    {currentAccount}
                  </DescriptionListItem>

                  {!editing && this.renderBankingInfoSummary()}
                  {editing && this.renderBankingInfoForm()}
                  {!this.props.details.all_banking_info_approved &&
                    canEdit &&
                    !editing && (
                      <div className="col-span-2 justify-self-center">
                        <button
                          className="button bg-orange-400 text-white px-8"
                          onClick={this.onOpenReviewBankingModal}
                        >
                          {t('REVIEW_BANKING_INFORMATION')}
                        </button>
                      </div>
                    )}
                </div>
              );
            }}
          </EditableSection>
        </div>
      </>
    );
  }
}

BillingForm.propTypes = {
  details: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  sensitiveDocumentData: PropTypes.array,
  onHandleBankingInfoAccept: PropTypes.func.isRequired,
  onHandleBankingInfoDecline: PropTypes.func.isRequired,
  onGetVerificationData: PropTypes.func.isRequired,
};

export default withTranslation()(formMixin(validationMixin(BillingForm)));
